import {
  HttpEvent,
  HttpRequest,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PSError } from '@ps/utils';
import { AuthActionsFacade, AuthSelectorsFacade } from '@ps/auth-data-access';
import { APP_ROUTES } from '@ps/core-config';
import { SKIP_FORBIDDEN_REDIRECT } from '@ps/core-data-access';

export function errorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const _authActionsFacade = inject(AuthActionsFacade);
  const _authSelectorsFacade = inject(AuthSelectorsFacade);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        _authSelectorsFacade.isAuthenticated() &&
        error.status === HttpStatusCode.Unauthorized
      ) {
        _authActionsFacade.clearAuth();
      }

      if (
        _authSelectorsFacade.isAuthenticated() &&
        error.status === HttpStatusCode.Forbidden &&
        !req.context.get(SKIP_FORBIDDEN_REDIRECT)
      ) {
        router.navigate([APP_ROUTES.NOT_FOUND]);
      }

      return throwError(() => PSError.http(error));
    }),
  );
}
